<template>
  <div v-if="get_hem_living_expense_access">
    <div style="float: right">
        <md-button
            class="md-icon-button md-primary md-simple new-app-button"
            style="padding: 10px"
            @click="toggleUploadDialog"
        >
            <md-icon id="new-app-icon">
            note_add
            </md-icon>
            New
            <md-tooltip md-direction="top">
                Upload new Hem Living Expense for Hem Living Expense Calculations
            </md-tooltip>
        </md-button>
        <loading-icon-button
            tooltip="Refresh"
            style="padding: 10px"
            @click="fetchHemLivingExpense"
        >
            refresh
        </loading-icon-button>
    </div>

    <upload-hem-living-expense
        :visible="uploadDialogVisible"
        :documents="documents"
        :supportedExt="supportedExt"
        @onCancel="toggleUploadDialog"
        @successUpload="uploadDocSuccess"
    >
    </upload-hem-living-expense>

    <data-table
      :headers="headers"
      v-model="get_hem_living_expense"
      title="Hem Living Expense"
    >
    </data-table>

    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UploadHemLivingExpense from '../components/Editors/UploadHemLivingExpense.vue';
import DataTable from "@/components/DataTable";
import LoadingIconButton from "@/components/LoadingIconButton";

export default {
  components: {
    UploadHemLivingExpense,
    DataTable,
    LoadingIconButton
  },
  computed: {
    ...mapGetters([
        "get_hem_living_expense_access",
        "get_hem_living_expense"
    ]),
  },
  data() {
    return {
        uploadDialogVisible : false,
        documents: [],
        supportedExt : ["csv"],
        error_dialog: {
            show: false,
            title: '',
            content: '',
        },
        headers: [
            {
                text: "Id",
                value: "id",
            },
            {
                text: "Document Name",
                value: "uploaded_document_name",
            },
            {
                text: "Uploaded On",
                value: "created_at",
            },
        ]
    }
  },
  methods: {
    async toggleUploadDialog () {
        this.uploadDialogVisible = !this.uploadDialogVisible
    },
    showUserDialog(title, message) {
        this.error_dialog.show = true;
        this.error_dialog.title = title;
        this.error_dialog.content = message;
    },
    async uploadDocSuccess () {
        await this.fetchHemLivingExpense();
        await this.toggleUploadDialog();
        // this.showDialog(
        //     `Failed to submit ${processName} request to pepper.`,
        //     `The request cannot be submitted for some reasons - \n` +
        //         errorMessage
        // );
    },
    async fetchHemLivingExpense () {
        await this.$store.dispatch('get_hem_living_expense');
    }
  },
  mounted() {
    this.fetchHemLivingExpense();
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.dialogWrapper {
  padding: 30px;
}

.error-message {
  color: red;
  padding: 6px;
  margin: 15px 30px;
  text-align: center;
}
</style>
